import React from 'react'
import '../PrivacyPolicy/PrivacyPolicy.css'
import Navbar from '../../Componect/Navbar/Navbar'
import FooterBottom from '../../Componect/Footer/FooterBottom'

function PrivacyPolicy() {
return (
    <>
    <div className='PrivacyPolicy'>
            <Navbar></Navbar>
            <div className='PrivacyPolicyTxt'>
            <p>
                <h1>Privacy Policy</h1>
            </p>
            <p>At স তে সতেরো, we value your privacy. This policy explains how we collect, use, and protect your information.</p>
            <ul>
                <li>
                    <strong>1. Information We Collect</strong>
                    <ul>
                        <li>Personal details (name, phone, email) for orders and inquiries.</li>
                        <li>Payment details (processed securely via third-party providers).</li>
                        <li>Website usage data (via cookies and analytics).</li>
                    </ul>
                </li>
                <li>
                    <strong>2. How We Use Your Information</strong>
                    <ul>
                        <li>To process orders and provide services.</li>
                        <li>To improve our website and customer experience.</li>
                        <li>To send offers and updates (if opted in).</li>
                    </ul>
                </li>
                <li>
                    <strong>3. Data Protection</strong>
                    <ul>
                        <li>We do not sell or share your personal data.</li>
                        <li>Your information is secured against unauthorized access.</li>
                    </ul>
                </li>
                <li>
                    <strong>4. Your Rights</strong>
                    <ul>
                        <li>You can request, update, or delete your data.</li>
                        <li>You can opt out of marketing communications anytime.</li>
                    </ul>
                </li>
                <li>
                    <strong>5. Contact Us</strong>
                    <ul>
                        <li>📧 Email: stesotero53@gmail.com</li>
                        <li>📞 Phone: 01780-126370</li>
                        <li>📍 Address: Sector-17, Block-I, Road-10, Plot-26, Uttara, Dhaka</li>
                    </ul>
                </li>
            </ul>
            <p>By using our services, you agree to this policy.</p>
            </div>
            <FooterBottom></FooterBottom>
    </div>
    </>
)
}

export default PrivacyPolicy